defineDs('DanskeSpil/Domain/PlayTogether/Scripts/Templates/CreateClub/Settings',
  [
    'Shared/Framework/Mithril/Scripts/Core/Mithril',
    'Shared/Framework/Ensighten/Scripts/Ensighten',
    'DanskeSpil/Domain/PlayTogether/Scripts/Helpers/Api',
    'DanskeSpil/Domain/PlayTogether/Scripts/Templates/Common/CtaButton',
    'DanskeSpil/Domain/PlayTogether/Scripts/Templates/Common/Card/CardContent',
    'DanskeSpil/Domain/PlayTogether/Scripts/Templates/Common/ClubSettings/SettingsOptions'
  ],
  function (m, Ensighten, PlayTogetherApi, CtaButton, CardContent, SettingsOptions) {

    var Settings = {
      controller: function (args) {
        Object.assign(this, args.controller);

        this.settingsDictionary = this.rootDictionary.get.bind({ prefix: 'CreateClub/Flow/Settings/' });

        this.helpOverlayTitle(this.settingsDictionary('HelpOverlay/Title'));
        this.helpOverlayDescription(this.settingsDictionary('HelpOverlay/Description'));

        this.flowTitle(this.settingsDictionary('Title'));
        this.flowDescription(this.settingsDictionary('Description', { clubName: this.clubName() }));
        this.property('flowGoBack', () => {
          this.currentStep('themeDesign');
          this.clubModel().save();
        });
        this.canEditClubName(false);

        // Create and invite:
        this.processingCreateClubAndInvite = m.prop(false);
        this.createClubAndInvite = () => {
          this.processingCreateClubAndInvite(true);
          PlayTogetherApi.createClub(this.clubModel().toJSON())
            .then((response) => {
              if (response.isOpenForRegistration) {
                window.location.href = this.navigationPaths.showInvitePage + '?klubId=' + response.groupId + '&fromCreationFlow=true';
              }
            })
            .catch((err) => {
              this.processingCreateClubAndInvite(false);
              this.error(err);
            });
        };

        // Create and go to club:
        this.processingCreateClubAndGoToClub = m.prop(false);
        this.createClubAndGoToClub = () => {
          this.processingCreateClubAndGoToClub(true);
          PlayTogetherApi.createClub(this.clubModel().toJSON())
            .then((response) => {
              window.location.href = this.navigationPaths.clubPage + '?klubId=' + response.groupId;
            })
            .catch((err) => {
              this.processingCreateClubAndGoToClub(false);
              this.error(err);
            });
        };

        setTimeout(() => {
          m.redraw();
        }, 0);

        Ensighten.pushGaEvent('spil_sammen', 'create_club', 'klub_indstillinger', null, true);
      },
      view: function (controller, ignoreArgs, { flowFooter }) {
        const footerContent = [
          CtaButton({
            text: controller.settingsDictionary('CreateAndInviteButton'),
            onClick: controller.createClubAndInvite,
            loading: controller.processingCreateClubAndInvite(),
            disabled: controller.processingCreateClubAndGoToClub(),
            options: ['primary']
          }),
          CtaButton({
            text: controller.settingsDictionary('CreateAndGoToClubButton'),
            onClick: controller.createClubAndGoToClub,
            loading: controller.processingCreateClubAndGoToClub(),
            disabled: controller.processingCreateClubAndInvite()
          })
        ];

        return CardContent({
          $content: m(SettingsOptions, { controller: controller }),
          $footer: flowFooter(footerContent)
        });
      }
    };

    // Public functions:
    return Settings;
  });
